import React from "react";
import { Card, CardContent, Grid, Typography, Box, Chip } from "@mui/material";
import { Pie, PieChart, Cell, Tooltip } from "recharts";

function EmployeeChart({ employeeData }) {
  // Ensure employeeData is in the correct format
  const chartData = Object.values(employeeData).map((item) => ({
    name: item.role, // Role name (e.g., Developer, Admin)
    count: item.count, // Number of employees in that role
  }));

  const COLORS = ["#ff4081", "#3f51b5", "#ffeb3b", "#4caf50", "#2196f3", "#9c27b0"]; // Different colors for each role

  return (
    <Grid item xs={12}>
      <Card sx={{ textAlign: "left", padding: 2,border: '2px solid #ccc',borderRadius: '8px'  }}>
        <CardContent sx={{ padding: 1 }}>
          {/* Grid container for Pie Chart and User Count */}
          <Grid container spacing={3}>
            {/* Left Side (Pie Chart + Title) */}
            <Grid item xs={12} sm={6}>
              <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 1 }}>
                Users Onboard
              </Typography>
              <Box display="flex" justifyContent="center" sx={{ mt:3,mr:2 }}>
                <PieChart width={200} height={200}>
                  <Pie
                    data={chartData}
                    dataKey="count"
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={100}
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </Box>
            </Grid>

            {/* Right Side (User Roles with Counts) */}
            <Grid item xs={12} sm={6}>
              <Box display="flex" flexDirection="column" alignItems="flex-start">
                {chartData.map((entry, index) => (
                  <Box key={index} display="flex" alignItems="center" sx={{  mt:3,ml:5  }}>
                    {/* Square box with respective color */}
                    <Box
                      sx={{
                        width: 20,
                        height: 20,
                        backgroundColor: COLORS[index % COLORS.length],
                        marginRight: 1,
                      }}
                    />
                    {/* Role name and count */}
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      {`${entry.count} - ${entry.name}`}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default EmployeeChart;
